import { cn } from '@playerbase/ui';
import {
  GAME_PLATFORM_LABELS,
  GAME_PLATFORM_ORDER,
  type GamePlatform,
} from '@playerbase/types';

type PlatformToggleProps = {
  selected: readonly GamePlatform[];
  onToggle: (platform: GamePlatform) => void;
  disabled?: boolean;
};

export function PlatformToggle({
  selected,
  onToggle,
  disabled = false,
}: PlatformToggleProps): JSX.Element {
  const selectedSet = new Set(selected);
  return (
    <div className="flex flex-wrap gap-2">
      {GAME_PLATFORM_ORDER.map((platform) => {
        const isSelected = selectedSet.has(platform);
        return (
          <button
            key={platform}
            type="button"
            disabled={disabled}
            aria-pressed={isSelected}
            onClick={() => onToggle(platform)}
            className={cn(
              'h-8 rounded-sm border px-3 text-xs font-mono uppercase tracking-wide',
              'transition-colors duration-150',
              'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-background',
              'disabled:pointer-events-none disabled:opacity-50',
              isSelected
                ? 'border-accent bg-accent-bg text-accent'
                : 'border-border-strong text-text-muted hover:border-text-muted hover:text-text',
            )}
          >
            {GAME_PLATFORM_LABELS[platform]}
          </button>
        );
      })}
    </div>
  );
}
